import {FormBuilder} from "../../FormBuilder";
import {RetrieverSource} from "./ValueRetrieverBase";
import {ContainerDataRetriever} from "FormBuilder/Core/FormBuilder.Model";


export class FormBuilderSource implements RetrieverSource{
    constructor(public FormBuilder:ContainerDataRetriever, public VariationName)
    {

    }

    public GetValue(){
        return this.FormBuilder.GetVariationValue(this.VariationName);
    }

    public GetIsUsed():boolean {
        return this.FormBuilder.ContainerManager.GetFields().some(x=>x.GetIsUsed()==true);
    }

    public GetIsVisible(): boolean {
        return this.FormBuilder.ContainerManager.GetFields().some(x=>x.GetIsVisible()==true);
    }

    GetPrice(): number {
        return 0;
    }

    GetText(): string {
        return "";
    }
}